const THEMES = { default: "Default", square: "Square" };
// eslint-disable-next-line import/prefer-default-export
export { THEMES };
